/* istanbul ignore file */
// We set the config object on window in _document
// @ts-ignore
const appConfig = typeof window === 'undefined' ? {} : window.__app_config;

const routingBasePath = appConfig.WEBUI_ROUTING_BASE_PATH;
const serverSideApiBasePath = `${routingBasePath}/api`;
const userManagementApiBasePath = appConfig.WEBUI_USER_MANAGEMENT_API_BASE_URL;
const segmentsApiBasePath = appConfig.WEBUI_SEGMENTS_API_BASE_URL;
const notificationsWssBasePath = appConfig.WEBUI_NOTIFICATIONS_WSS_BASE_URL;
// TODO(jbellmont): Remove once Dashboard Gateway is in prod.
const dashboardGatewayBasePath = appConfig.WEBUI_DASHBOARD_GATEWAY_BASE_URL;
const prismApiBasePath = appConfig.WEBUI_PRISM_API_BASE_URL;
const prismInsightsApiBasePath = appConfig.WEBUI_INSIGHTS_API_BASE_URL;
const networkTokensApiBasePath = appConfig.WEBUI_NETWORK_TOKENS_API_BASE_URL;

const app = {
  name: appConfig.WEBUI_APP_NAME,
  version: appConfig.WEBUI_APP_VERSION,
  env: appConfig.WEBUI_ENV_NAME,
  heapID: appConfig.WEBUI_HEAP_ID,
};

export const api = {
  dashboardGatewayBasePath,
  notificationsWssBasePath,
  segmentsApiBasePath,
  serverSideApiBasePath,
  userManagementApiBasePath,
  prismApiBasePath,
  prismInsightsApiBasePath,
  networkTokensApiBasePath,
};

export const internalNavigationQueryKey = 'in' as const;

const oktaServiceURL = appConfig.WEBUI_OKTA_SERVICE_URL!;
const okta = {
  serviceURL: oktaServiceURL,
  issuer: oktaServiceURL + appConfig.WEBUI_OKTA_ISSUER!,
  clientID: appConfig.WEBUI_OKTA_CLIENT_ID!,
  redirectUri: `${routingBasePath}/implicit/callback`,
  postLogoutRedirectUri: routingBasePath,
  appEmbedLinkID: appConfig.WEBUI_OKTA_EMBED_LINK_ID!,
  recoveryPassword: `${oktaServiceURL}/api/v1/authn/recovery/password`,
  recoveryToken: `${oktaServiceURL}/api/v1/authn/recovery/token`,
  resetPassword: `${oktaServiceURL}/api/v1/authn/credentials/reset_password`,
  silentLogin: `${oktaServiceURL}/api/v1/authn`,
  clientsSelectorURL: `${userManagementApiBasePath}/umt/clients/selector`,

  userProfileApiBasePath: `${userManagementApiBasePath}/umt/users`,
  usersApiBasePath: `${userManagementApiBasePath}/umt`,
};

// TODO(https://checkout.atlassian.net/browse/AKA-2289): remove after unified user accounts are done
const isAlternativeOktaAccessEnabled = appConfig.WEBUI_ALTERNATIVE_OKTA_IS_ENABLED!;
const alternativeOktaServiceURL = appConfig.WEBUI_ALTERNATIVE_OKTA_SERVICE_URL!;
const alternativeOktaQueryParameter = appConfig.WEBUI_ALTERNATIVE_OKTA_QUERY_PARAMETER!;
const alternativeOkta = {
  serviceURL: alternativeOktaServiceURL,
  issuer: alternativeOktaServiceURL + appConfig.WEBUI_ALTERNATIVE_OKTA_ISSUER!,
  clientID: appConfig.WEBUI_ALTERNATIVE_OKTA_CLIENT_ID!,
  redirectUri: `${routingBasePath}/implicit/callback?${alternativeOktaQueryParameter}=true`,
  postLogoutRedirectUri: routingBasePath,
  appEmbedLinkID: appConfig.WEBUI_ALTERNATIVE_OKTA_EMBED_LINK_ID!,
  recoveryPassword: `${alternativeOktaServiceURL}/api/v1/authn/recovery/password`,
  recoveryToken: `${alternativeOktaServiceURL}/api/v1/authn/recovery/token`,
  resetPassword: `${alternativeOktaServiceURL}/api/v1/authn/credentials/reset_password`,
  silentLogin: `${alternativeOktaServiceURL}/api/v1/authn`,
  clientsSelectorURL: `${userManagementApiBasePath}/umt/clients/selector`,

  userProfileApiBasePath: `${userManagementApiBasePath}/umt/users`,
  usersApiBasePath: `${userManagementApiBasePath}/umt`,
};

// TODO(https://checkout.atlassian.net/browse/AKA-2289): remove after unified user accounts are done
const resolveOktaSettings = () => {
  const queryString = window.location.search;
  const queryParams = new URLSearchParams(queryString);

  if (isAlternativeOktaAccessEnabled && queryParams.get(alternativeOktaQueryParameter) === 'true') {
    return alternativeOkta;
  }

  return okta;
};

const launchDarkly = {
  clientSideID: appConfig.WEBUI_LAUNCHDARKLY_CLIENT_SIDE_ID,
};

const datadog = {
  appId: 'f9d7c1b5-28e8-4077-ac71-2f1fd115fcfe',
  clientToken: 'pubce6058d25ed5f83364517630a8a07cc7',
};

const support = {
  botKey: appConfig.WEBUI_SUPPORT_BOT_PUBLIC_KEY,
  signedJWTUrl: appConfig.WEBUI_SUPPORT_SIGNED_JWT_URL,
  tokenFieldId: appConfig.WEBUI_SUPPORT_TOKEN_FIELD_ID,
};

const settings = {
  api,
  app,
  datadog,
  launchDarkly,
  microfrontendConfig: appConfig.WEBUI_MICROFRONTENDS,
  okta: resolveOktaSettings(),
  support,
};

export default settings;
